import React, { Component } from 'react';
import { connect } from 'react-redux';

import Papa from 'papaparse';

import ImportComplete from './ImportComplete';
import ImportInput from './ImportInput';
import ImportPending from './ImportPending';

import sectionStyles from './_styles/ManageSection.module.scss';
import styles from './_styles/ManageImport.module.scss';

import * as ddnyActionCreators from '../../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class ManageImport extends Component {

	constructor(props) {
		super(props);
		this.state = {
			importPending: false,
			importComplete: false,
			importData: {},

			requestError: null,
			requestPending: false,
			
			csvTotalRecords: null,
			csvProcessedRecords: 0,
		};
	}

	initiateUpload(csvFile) {

		if(!csvFile)  { return null; }

		this.setState({
			requestError: null,
			requestPending: true,

			importPending: true,
			importComplete: false,
			
			csvTotalRecords: null,
			csvProcessedRecords: 0,
		});

		Papa.parse(csvFile, {
			worker: true,
			header: true,
			skipEmptyLines: true,
			complete: (results) => {
				this.setState({
					csvTotalRecords: results.data.length,
				}, () => {
					this.makeAsyncRequest(results, csvFile.path);
				});
			},
		});
	}

	async makeAsyncRequest(csvData, filename) {

		const UPLOAD_BLOCK_SIZE = 100;
		const records = csvData.data;

		for (let i = 0; i < records.length; i += UPLOAD_BLOCK_SIZE) {

			const chunk = records.slice(i, i + UPLOAD_BLOCK_SIZE);

			const splitData = {
				records: chunk,
			};

			try {
				await this.props.ddnyFetchProductBulkUpload(splitData);

				this.setState({ csvProcessedRecords: this.state.csvProcessedRecords + splitData.records.length });

			} catch (errResp) {
				console.error("Error uploading batch starting at index", i, errResp);
			}
		}

		this.setState({
			requestError: null,
			requestPending: false,

			importPending: false,
			importComplete: true,
		});
	}

	render() {

		return <div className={`${styles.ManageImport} ${sectionStyles.ManageSection}`}>
			<div className={sectionStyles.sectionTitle}>Import Products</div>
			<div className={sectionStyles.sectionBody}>
				{!this.state.importPending && !this.state.importComplete
					?	<ImportInput initiateUpload={this.initiateUpload.bind(this)} />
					:	<>
							{!this.state.importComplete
								?	<ImportPending
										progress={this.state.csvTotalRecords ? parseFloat(this.state.csvProcessedRecords / this.state.csvTotalRecords) : 0} />
								:	<ImportComplete />
							}
						</>
				}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(ManageImport);

